import { Navigate } from 'react-router';
import Layout from '../components/layout/Layout';

const SuperRoute = ({ isLogin, role }) => {
  return isLogin && role === 'super' ? <Layout /> : <Navigate to='/' />;
};
export default SuperRoute;
